<template>
  <sp-select
    class="specialty-picker"
    multiple
    selected-tags
    selection-clearable
    searchable
    fuzzy-search
    keep-open-on-select
    max-results="100"
    :label="store.config.specialtySelectLabel"
    :items.prop="store.specialtyOptions"
    :value.prop="store.selectedSpecialtyIds"
    :data-testid="TestId.assignSpecialties.specialtySelect"
    @input="handleInput"
  ></sp-select>
</template>

<script setup>
import { TestId } from "#/test-ids";
import { firstDetail } from "#ce/utils/events";
import { useAssignSpecialtiesStore } from "#ce/apps/SpAdmin/SpAssignSpecialtiesApp/store/assign-specialties";

const store = useAssignSpecialtiesStore();

function handleInput(event) {
  store.selectedSpecialtyIds = firstDetail(event) ?? [];
}
</script>

<style scoped>
.specialty-picker {
  display: block;
}
</style>
